module.exports = __webpack_public_path__ + "static/media/smoothWhite.228a2a1b.PNG";